<template>
  <div>
    <div id="captcha-button" ref="captchaBtn"></div>
    <div id="captcha-element"></div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { createOrderV2 } from "@src/service/preorder/index.js";
let onlythat = "";
export default {
  props: {},
  data() {
    return {
      resultData: "",
      captcha: null,
      captchaButton: null,
      payData: ""
    };
  },
  mounted() {
    this.captchaButton = document.getElementById("captcha-button");
    onlythat = this;
    window.initAliyunCaptcha({
      SceneId: "13ju2q1q", // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: "w5sqqe", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: "#captcha-button", // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 360,
        height: 40
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: "cn" // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
  },
  beforeUnmount() {
    this.captchaButton = null;

    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    document.getElementById("aliyunCaptcha-mask") &&
      document.getElementById("aliyunCaptcha-mask").remove();
    document.getElementById("aliyunCaptcha-window-popup") &&
      document.getElementById("aliyunCaptcha-window-popup").remove();
  },
  methods: {
    btnFun() {
      const that = this;
      try {
        this.$nextTick(() => {
          console.log("唤起事件1");
          that.payData = this.$parent.payData();
          sessionStorage.setItem("payDataAnli",JSON.stringify(that.payData))
          const event = new MouseEvent("click", {
            bubbles: true,
            cancelable: true
          });
          document.getElementById("captcha-button").dispatchEvent(event);
        });
      } catch (err) {
        Toast({
          message: err,
          position: "center",
          duration: 5000
        });
      }
    },
    getInstance(instance) {
      this.captcha = instance;
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      const that = this;
      // 1.向后端发起业务请求，获取验证码验证结果和业务结果
      // const result = await xxxx('http://您的业务请求地址', {
      //     captchaVerifyParam: captchaVerifyParam, // 验证码参数
      //     yourBizParam... // 业务参数
      // });
      // return {
      //  captchaResult: true, // 验证码验证是否通过，boolean类型，必选
      //  bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
      // }
      try {
        let payData = {};
        try{
          payData = onlythat.$parent.payData()
        }catch (err) {
          if(that.payData){
            payData = that.payData;
          }else{
            payData = sessionStorage.getItem("payDataAnli")?JSON.parse(sessionStorage.getItem("payDataAnli")):{}
          }
        }
        const res = await createOrderV2({
          ...payData,
          ...{ captchaVerifyInfo: captchaVerifyParam }
        });
        if (res && res.status == 0) {
          onlythat.$emit("onBizResultCallback", res.data);
          return {
            captchaResult: true,
            bizResult: true
          };
        } else {
          if (
            res.status != 6803038 &&
            res.status != 6803039 &&
            res.status != 6803040
          ) {
            Toast({
              message: res.msg || "创建订单失败",
              position: "bottom",
              duration: 5000
            });
            return {
              captchaResult: true,
              bizResult: true
            };
          }
          return {
            captchaResult: false,
            bizResult: false
          };
        }
      } catch (err) {
        Toast({
          message: err,
          position: "bottom",
          duration: 5000
        });
      }
      //this.$parent.toPayApi("", captchaVerifyParam);
      // console.log(res)
      // if (res) {
      //   this.$emit('onBizResultCallback',res)
      //   return {
      //     captchaResult: true,
      //     bizResult: true
      //   };
      // } else {
      //   return {
      //     captchaResult: false,
      //     bizResult: false
      //   };
      // }
    },
    // 验证通过后调用
    onBizResultCallback() {
      // const resultDataAli = sessionStorage.getItem("resultDataAli")?JSON.parse(sessionStorage.getItem("resultDataAli")):{};
      // if(resultDataAli && resultDataAli.payOrderId){
      //   //this.$parent.onBizResultCallback(resultDataAli)
      //   onlythat.$emit("onBizResultCallback", resultDataAli);
      //   sessionStorage.removeItem("resultDataAli");
      // }
    }
  }
};
</script>

<style>
#captcha-button {
  z-index: 99;
  width: 150px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  color: #fff;
  padding: 8px 0;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}
</style>
